import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/ToBePlannedActions";
import * as api from "../../api/ToBePlannedApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";

function* getToBePlanneds(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getToBePlanneds(action.payload);
        yield put(actions.setToBePlanneds(data || undefined));
    } catch (error) {
        yield put(actions.setToBePlanneds(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getRecordStatusList() {
    try {
        const { data } = yield api.getRecordStatusList();
        yield put(actions.setRecordStatusList(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setRecordStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getToBePlannedDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getToBePlannedDetailById(action.payload);
        yield put(actions.setToBePlannedDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setToBePlannedDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addToBePlanned(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addToBePlanned(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateToBePlanned(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateToBePlanned(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteToBePlanned(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteToBePlanned(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* convertToPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.convertToPlannedMaintenance(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_TOBEPLANNEDS, getToBePlanneds);
    yield takeEvery(actions.Types.GET_RECORDSTATUSLIST, getRecordStatusList);
    yield takeEvery(actions.Types.GET_TOBEPLANNED_DETAIL_BY_ID, getToBePlannedDetailById);
    yield takeEvery(actions.Types.ADD_TOBEPLANNED, addToBePlanned);
    yield takeEvery(actions.Types.UPDATE_TOBEPLANNED, updateToBePlanned);
    yield takeEvery(actions.Types.DELETE_TOBEPLANNED, deleteToBePlanned);
    yield takeEvery(actions.Types.CONVERT_TO_PLANNED_MAINTENANCE, convertToPlannedMaintenance);
}

const ToBePlannedSaga = [fork(watchAll)];

export default ToBePlannedSaga;
